//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IngestManagementState } from '@/redux/slices/slice_types';
import { SelectedTitles } from '@/components/IngestManagement/FileIngest/TitleAssociation';
import { SelectedTitlesV2 } from '@/components/IngestManagement/FileIngest/TitleAssociationV2/TitleAssociationV2';

const initialState: IngestManagementState = {
  selectedTitles: [],
  recentTitles: [],
  selectedRecentTitles: null,
  registerAgainst: null
};

const ingestManagementSlice = createSlice({
  name: 'ingestManagement',
  initialState,
  reducers: {
    addRecentTitle: (state, { payload }: PayloadAction<SelectedTitles | SelectedTitlesV2 | null>) => {
      if (!payload) return;
      const selectedTitles = payload;
      const recentTitles = [...state.recentTitles];
      if (recentTitles.length > 0 && recentTitles.find((t) => t.at(-1)?.value?.id === selectedTitles.at(-1)?.value?.id)) {
        const index = recentTitles.findIndex((t) => t.at(-1)?.value?.id === selectedTitles.at(-1)?.value?.id);
        const removedTitle = recentTitles.splice(index, 1)[0];
        recentTitles.unshift(removedTitle);
        state.recentTitles = [recentTitles];
        return;
      }
      recentTitles.unshift(selectedTitles);
      state.recentTitles = recentTitles.slice(0, 5);
    },
    setSelectedTitles: (state, { payload }: PayloadAction<SelectedTitles | SelectedTitlesV2>) => {
      state.selectedTitles = payload;
    },
    setSelectedRecentTitles: (state, { payload }: PayloadAction<SelectedTitles | SelectedTitlesV2 | null>) => {
      state.selectedRecentTitles = payload;
    },
    setRegisterAgainst: (state, { payload }) => {
      state.registerAgainst = payload;
    },
    resetIngestManagement: (state) => {
      state.selectedTitles = initialState.selectedTitles;
      state.recentTitles = initialState.recentTitles;
      state.selectedRecentTitles = initialState.selectedRecentTitles;
      state.registerAgainst = initialState.registerAgainst;
    }
  }
});

export const { addRecentTitle, setSelectedTitles, setSelectedRecentTitles, setRegisterAgainst, resetIngestManagement } =
  ingestManagementSlice.actions;

export default ingestManagementSlice.reducer;
